module.exports = __webpack_public_path__ + "static/media/mo.a60c624e.svg";